<template>
  <div class="check-index">
    <!-- 抬头 -->
    <div class="head">
      <h4>查看问卷</h4>
      <div>
        <el-button size="small" type="primary" @click="exportData">导出数据</el-button>
        <el-button size="small" type="info" @click="backProject">返回</el-button>
      </div>
    </div>
    <!-- 抬头结束 -->
    <div class="check-contents">
      <el-table :data="questionnairesObject.list" style="width: 100%;" :header-cell-style="headStyle"
        :cell-style="rowStyle">
        <el-table-column prop="id" label="序号" width="180">
        </el-table-column>
        <el-table-column prop="nickname" label="微信昵称">
        </el-table-column>
        <el-table-column prop="img" label="微信头像">
          <template slot-scope="scope">
            <div class="table-avatar"><img :src="scope.row.avatar"></div>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间">
        </el-table-column>
        <el-table-column prop="address" label="操作" width="120">
          <template slot-scope="scope">
            <div class="check-contents-check" @click="viewQuestionnaires(scope.row)">
              <div class="check-contents-check-img">
                <img src="./../../../assets/image/questionnaires/查看 (2).png">
              </div>
              <div class="check-contents-check-text">查看问卷</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="page" v-show="questionnairesObject.tableData != 0">
      <el-pagination background layout="prev, pager, next" @current-change="currentchange" @prev-click="prevClick"
        @next-click="nextClick" :page-count="questionnairesObject.pages" :current-page.sync="currentPage"
        hide-on-single-page>
      </el-pagination>
    </div>
    <!-- 分页 -->
  </div>
</template> 
 
<script>
export default {
  name: 'check',
  data() {
    return {
      total: 0,//总条目数
      pagesize: 8,//每页显示条目个数
      currentPage: 1,//当前页数
      questionnairesObject: {}//列表
    }
  },
  created() {
    this.getCheckquestionnairesList()
  },
  methods: {
    //导出数据
    exportData() {
      //https://laravel.gongshicloud.com/ //!更新线上需要更换域名
      window.open(`https://laravel.gongshicloud.com/api/survery/export?id=${this.$route.query.id}`)
    },
    //获取列表     
    async getCheckquestionnairesList() {
      const { data: data } = await this.$http.post('survery/check-list', {
        page: this.currentPage,
        limit: this.pagesize,
        id: this.$route.query.id
      })
      this.questionnairesObject = data.data
      this.$Spin.hide();
    },
    //查看问卷
    viewQuestionnaires(item) {
      //id survey_id userid
      this.$router.push({
        path: '/questionnaires/answersView',
        query: {
          id: item.id,
          userid: item.userid,
          survey_id: item.survey_id,
        }
      })
    },
    //表头居中
    headStyle() {
      return "text-align:center;background:#ECF4FF;color:#2C2C2C;line-height: 38px;font-size: 16px;font-weight: 200;"
    },
    //表格居中   
    rowStyle() {
      return "text-align:center;font-size: 14px;cursor: pointer;"
    },
    //点击每一页 
    currentchange(e) {
      this.currentPage = e
      setTimeout(() => {
        this.getCheckquestionnairesList()
      }, 500)
      this.$Spin.show();
    },
    //上一页  
    prevClick(e) {
      this.currentPage = e
      setTimeout(() => {
        this.getCheckquestionnairesList()
      }, 500)
      this.$Spin.show();
    },
    //下一页
    nextClick(e) {
      this.currentPage = e
      setTimeout(() => {
        this.getCheckquestionnairesList()
      }, 500)
      this.$Spin.show();
    },
    //返回
    backProject() {
      this.$router.back()
    },
  }
}

</script>
<style lang="less" scoped>
.check-index {
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;

    h4 {
      font-size: 28px;
      color: #212529;
    }
  }

  .check-contents {
    width: 100%;
    min-height: 670px;
    background-color: #fff;
    border-radius: 8px;
    padding: 52px 45px;
    transition: 0.6s all;

    .check-contents-check {
      display: flex;
      align-items: center;

      .check-contents-check-img {
        width: 18px;
        height: 22px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .check-contents-check-text {
        font-size: 14px;
        color: #4949d9;
        margin: 8px 0 0 5px;
      }
    }

    /deep/ .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
      border: 0 !important;
    }

    /deep/.el-table th.el-table__cell.is-leaf {
      border: 0 !important;
    }
  }

  /deep/ .el-table::before {
    height: 0px;
  }

  /deep/ .el-table .cell {
    line-height: 38px !important;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .table-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    text-align: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .page {
    text-align: right;
  }
}
</style>   